import type { AddFileKeysPayload, MissingFileKeyHelpRequest } from '@/types/fileKey/FileKeyFacilitation';
import type { UploadRotatedFileKeysPayload } from '@/types/fileKey/FileKeyRegeneration';

export abstract class FileKeyFacilitationService {
  abstract getMissingFileKeyRequests(): Promise<MissingFileKeyHelpRequest[]>;
  /** Hands a tar of re-encrypted key blobs to HAP; the fetcher polls the command to completion. */
  abstract uploadFileKeysBundle(payload: UploadRotatedFileKeysPayload): Promise<void>;
  /** Submits every recipient's file-to-CID pairs as one command; the fetcher polls to completion. */
  abstract submitFileKeys(payload: AddFileKeysPayload): Promise<void>;
}
